<template>
  <v-app-bar
    app
    class="main-toolbar"
    :color="!isStandalone ? 'blue' : 'white'"
    :dark="!isStandalone"
    fixed
    :tabs="!!$slots['tabs']"
    flat
  >
    <v-btn v-if="prevRoute" icon tag="v-btn" elevation="0" @click="$router.push(prevRoute)">
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
    <v-btn v-else-if="toggleDrawer" elevation="0" tag="v-btn" icon @click="$emit('toggleDrawer')">
      <v-icon>mdi-menu</v-icon>
    </v-btn>

    <v-img
      class="mr-3"
      contain
      max-height="30"
      max-width="100"
      height="30px"
      src="https://file.usail.es/static/usail-logo-white.svg"
    />

    <v-toolbar-title>
      <template v-if="title">
        {{ title }}
      </template>
      <template v-else>Account</template>
    </v-toolbar-title>
    <v-spacer></v-spacer>

    <slot name="buttons"></slot>

    <ToolbarApps v-if="!isStandalone"></ToolbarApps>
    <ToolbarUser></ToolbarUser>

    <slot slot="extension" name="tabs"></slot>
  </v-app-bar>
</template>

<script>
import ToolbarUser from '@/components/ToolbarUser'
import ToolbarApps from '@/components/ToolbarApps'

export default {
  components: {
    ToolbarUser,
    ToolbarApps
  },

  props: {
    title: {
      type: String,
      required: false,
      default: null
    },
    prevRoute: {
      type: Object,
      required: false,
      default: null
    },
    toggleDrawer: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    isStandalone() {
      return window.matchMedia('(display-mode: standalone)').matches
    }
  }
}
</script>
